var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("search-toolbar", {
        attrs: {
          resultType: "staffs",
          from: _vm.from,
          to: _vm.to,
          sortFields: _vm.sortFields,
          totalCount: _vm.totalCount
        },
        on: {
          search: function($event) {
            return _vm.getStaffs($event)
          },
          clearsearch: function($event) {
            return _vm.clearSearch($event)
          },
          changeSort: function($event) {
            return _vm.changeSort($event)
          }
        }
      }),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "md-layout", attrs: { id: "stafflist" } },
        _vm._l(_vm.staffs, function(staff, index) {
          return _c(
            "div",
            {
              key: index,
              staticClass:
                "md-layout-item md-medium-size-33 md-small-size-50 md-xsmall-size-100",
              class: _vm.staffEnable(staff) ? "staff-enable-opacity" : "",
              attrs: { title: _vm.staffEnable(staff) ? "disabled staff" : "" }
            },
            [
              _c(
                "md-list",
                { staticClass: "md-double-line" },
                [
                  _c(
                    "md-list-item",
                    [
                      _c("md-avatar", [
                        _c("img", {
                          staticClass: "staff-image",
                          attrs: {
                            src: _vm.displayPicture(staff),
                            alt: staff.name
                          },
                          on: { error: _vm.onError }
                        })
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "md-list-item-text" }, [
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(_vm.setDisplayName(staff))
                          }
                        }),
                        _vm._v(" "),
                        staff.email
                          ? _c("span", {
                              domProps: { textContent: _vm._s(staff.email) }
                            })
                          : _vm._e(),
                        _vm._v(" "),
                        _c("span", {
                          domProps: {
                            textContent: _vm._s(_vm.displayStaffRoles(staff))
                          }
                        })
                      ]),
                      _vm._v(" "),
                      _c("md-avatar", [
                        _vm.staffIsServiceAccount(staff)
                          ? _c("img", {
                              attrs: {
                                src: require("../../../assets/img/integration_icon.png"),
                                alt: "integration user",
                                title: "integration user"
                              }
                            })
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _vm.hasCertainRoleId(
                        staff,
                        "db861299-e18d-4d29-be64-02d675c98a25"
                      )
                        ? _c(
                            "md-button",
                            {
                              directives: [
                                { name: "can-edit", rawName: "v-can-edit" }
                              ],
                              staticClass: "md-raised md-primary",
                              attrs: { disabled: _vm.sending },
                              on: {
                                click: function($event) {
                                  return _vm.removeStaff(staff)
                                }
                              }
                            },
                            [_vm._v("Remove")]
                          )
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        }),
        0
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [{ name: "can-edit", rawName: "v-can-edit" }],
          staticClass: "md-layout-item md-small-size-100 right-align"
        },
        [
          _c(
            "md-button",
            {
              staticClass: "md-raised md-primary",
              attrs: { disabled: _vm.sending },
              on: {
                click: function($event) {
                  return _vm.inviteTechnogymStaff()
                }
              }
            },
            [_vm._v("Invite technogym\n      staff")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("dialog-custom", {
        attrs: { parentref: _vm.parentref, showDialog: _vm.showDialog },
        on: { hidedialog: _vm.hidedialog }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b0691e76", { render: render, staticRenderFns: staticRenderFns })
  }
}